<div class="modal-header">
    <h2 class="modal-title">{{ azione }} opera secondaria</h2>
    <button class="close" type="button" aria-label="Chiudi" (click)="activeModal.close()" tabindex="0">
        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
    </button>
</div>
<div class="modal-body">
    <form class="form" role="form" [formGroup]="criteriaForm">
        <div class="form-row">
            <div class="form-group col-md-4">
                <label for="idFunzionePrevalente">Funzione prevalente</label>
                <select class="form-control" formControlName="idFunzionePrevalente" id="idFunzionePrevalente">
                    <!-- <option [ngValue]="null">Seleziona un'opzione...</option> -->
                    <option *ngFor="let item of datalist.funzionePrevalente" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="macroTipologiaOpera">Categoria/Macrotipologia opera</label>
                <select class="form-control" formControlName="macroTipologiaOpera" id="macroTipologiaOpera" (change)="searchTipologiaOperaByMacroTipologiaOpera()">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.macroTipologiaOpera" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="idTipologiaOpera">Tipologia opera</label>
                <select class="form-control" formControlName="idTipologiaOpera" id="idTipologiaOpera">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of tipologiaOperaFiltered" [ngValue]="item.idTipologiaOpera">{{ item.descrizioneTipologiaOpera }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="idMaterialeCostruzione">Materiale costruzione</label>
                <select class="form-control" formControlName="idMaterialeCostruzione" id="idMaterialeCostruzione">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.materiale" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="idMaterialeRivestimento">Materiale rivestimento</label>
                <select class="form-control" formControlName="idMaterialeRivestimento" id="idMaterialeRivestimento">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.materiale" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <!-- <div class="form-group col-md-4">
                <label for="idSponda">Sponda</label>
                <select class="form-control" formControlName="idSponda" id="idSponda">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.sponda" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div> -->
        </div>
        <div class="form-row">
            <div class="form-group col-md-4">
                <label for="quotaMinMetri">Quota minima (metri)</label>
                <input onlyNumbers class="form-control" id="quotaMinMetri" formControlName="quotaMinMetri" type="number">
            </div>
            <div class="form-group col-md-4">
                <label for="quotaMedMetri">Quota media (metri)</label>
                <input onlyNumbers class="form-control" id="quotaMedMetri" formControlName="quotaMedMetri" type="number">
            </div>
            <div class="form-group col-md-4">
                <label for="quotaMaxMetri">Quota massima (metri)</label>
                <input onlyNumbers class="form-control" id="quotaMaxMetri" formControlName="quotaMaxMetri" type="number">
            </div>
            <div class="form-group col-md-4">
                <label for="altezzaMetri">Altezza (metri)</label>
                <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="altezzaMetri" formControlName="altezzaMetri" type="text">
            </div>
            <div class="form-group col-md-4">
                <label for="lunghezzaMetri">Lunghezza (metri)</label>
                <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="lunghezzaMetri" formControlName="lunghezzaMetri" type="text">
            </div>
            <div class="form-group col-md-4">
                <label for="larghezzaMetri">Larghezza (metri)</label>
                <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="larghezzaMetri" formControlName="larghezzaMetri" type="text">
            </div>
            <div class="form-group col-md-4">
                <label for="volumeMC">Volume (metri cubi)</label>
                <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="volumeMC" formControlName="volumeMC" type="text">
            </div>
            <div class="form-group col-md-4">
                <label for="areaMQ">Area (metri quadri)</label>
                <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="areaMQ" formControlName="areaMQ" type="text">
            </div>
            <div class="form-group col-md-12">
                <label for="note">Note</label>
                <textarea class="form-control" id="note" formControlName="note" [value]="criteriaForm.get('note')?.value | specialCharacters"></textarea>
            </div>
        </div>
    </form>
    <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
</div>
<div class="modal-footer">
    <button type="button" tabindex="0" (click)="activeModal.close()" class="btn btn-outline-primary">Chiudi</button>
    <button *ngIf="canEdit" type="button" tabindex="0" (click)="saveOperaSecondaria()" class="btn btn-primary">Salva</button>
</div>